// removed by extract-text-webpack-plugin
module.exports = {"header":"HistoryHeader__header___1-cF5"};